import { branch, withProps, compose } from 'recompose';
import ErrorPage from '../../routes/ErrorPage';

const withFatalErrorWhen = (conditionFunc, code) => Component => {
  const ErrorBranch = compose(
    withProps(props => ({
      ...props,
      errorStatus: conditionFunc(props) ? code : null
    })),
    branch(({ errorStatus }) => !!errorStatus, () => ErrorPage)
  )(Component);

  ErrorBranch.displayName = Component.displayName;
  ErrorBranch.fragment = Component.fragment;

  return ErrorBranch;
};

export default withFatalErrorWhen;
export const with500ErrorWhen = conditionFunc =>
  withFatalErrorWhen(conditionFunc, 500);
export const with404ErrorWhen = conditionFunc =>
  withFatalErrorWhen(conditionFunc, 404);
